import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/plus-jakarta-sans';
import './index.css';
import App from './App';
import { AuthContextProvider } from './store/auth-context';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ErrorBoundary from './components/common/ErrorBoundary';
import { ThemeProvider } from './contexts/ThemeContext';
import './styles/DarkMode.css';

// Suppress fetch errors during react-snap pre-rendering so the build doesn't crash
const isPrerendering = navigator.userAgent.includes('ReactSnap');
if (isPrerendering) {
  window.addEventListener('error', (e) => {
    if (e.message && e.message.includes('Failed to fetch')) {
      e.preventDefault();
    }
  });
  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason && e.reason.message && e.reason.message.includes('Failed to fetch')) {
      e.preventDefault();
    }
  });
}

const rootElement = document.getElementById('root');

const appTree = (
  <React.StrictMode>
    <HelmetProvider>
      {/*
        GoogleOAuthProvider deliberately does NOT wrap the app. Mounting it
        injects Google's Identity Services SDK — 98 KB, 83% of it unused —
        on every page load, including content pages nobody signs in from. It
        is now scoped to the three components that render a Google button,
        via <GoogleAuthScope>. See components/common/GoogleAuthScope.jsx.
      */}
      <ThemeProvider>
        <AuthContextProvider>
          <Router>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </Router>
        </AuthContextProvider>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// Always use createRoot instead of hydrateRoot.
// react-snap pre-renders for SEO (crawlers see the HTML), but hydrateRoot
// causes #418 errors because the AdSense script modifies the DOM before
// React hydrates, creating a mismatch. createRoot just replaces the
// pre-rendered HTML with the live React tree — SEO is unaffected since
// crawlers don't execute JS hydration.
const root = ReactDOM.createRoot(rootElement);
root.render(appTree);
